import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom'; // Importa useLocation
import IconLanguage from '../assets/icone/header/iconLanguage.svg';
import iconItaly from '../assets/icone/language/iconItaliano.svg';
import iconEng from '../assets/icone/language/iconInglese.svg';
import iconSpanish from '../assets/icone/language/iconSpagnolo.svg';
import iconFrench from '../assets/icone/language/iconFrancese.svg';

const LanguageSwitcher = () => {
  const { i18n, ready } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation(); // Usa useLocation

  useEffect(() => {
    // Quando la route cambia, chiudi il menu
    setMenuOpen(false);
  }, [location]);

  if (!ready) {
    return <div>Loading...</div>;
  }

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setMenuOpen(false);
  };

  const currentLanguage = i18n.language;

  const getLanguageIcon = (lang) => {
    switch (lang) {
      case 'it':
        return <img src={iconItaly} alt="Italian Icon" className="lg:w-6 md:w-4 pt-2" />;
      case 'en':
        return <img src={iconEng} alt="English Icon" className="lg:w-6 md:w-4 pt-2" />;
      case 'fr':
        return <img src={iconFrench} alt="French Icon" className="lg:w-6 md:w-4 pt-2" />;
      case 'es':
        return <img src={iconSpanish} alt="Spanish Icon" className="lg:w-6 md:w-4 pt-2" />;
      default:
        return <img src={IconLanguage} alt="Language Icon" className="lg:w-6 md:w-4 pt-2" />;
    }
  };

  return (
    <div className="relative z-50">
      <button className="text-3xl" onClick={toggleMenu}>
        {getLanguageIcon(currentLanguage)}
      </button>
      {menuOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-300 rounded-lg shadow-lg">
          <button
            className="block w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100"
            onClick={() => changeLanguage('it')}
          >
            <img src={iconItaly} alt="Italian Icon" className="inline-block w-5 mr-2" />
            Italiano
          </button>
          <button
            className="block w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100"
            onClick={() => changeLanguage('en')}
          >
            <img src={iconEng} alt="English Icon" className="inline-block w-5 mr-2" />
            English
          </button>
          {/* Puoi aggiungere altri bottoni per altre lingue */}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
